<div class="rec-container ">
  <h2>Search Recorded Land by</h2>
  <form (ngSubmit)="onSubmit($event)" #f="ngForm">

    <div class="date-container">
      <!--<app-daterange></app-daterange>-->
      <lib-date-range-parent></lib-date-range-parent>
    </div>
    <div class="city-container">
      <app-city-town-ex></app-city-town-ex>
    </div>
    <div class="doc-container">
      <app-doctypeex></app-doctypeex>
    </div>
    <button class="btn btn-default" type="submit">
      SEARCH
    </button>

    <!--<button class="btn btn-default" type="button" (click)="search('/rec-date-result-pg')">
    SEARCH
  </button>-->
  </form>
</div>

